<template>
<dinos-punch></dinos-punch>
</template>

<script>
import DinosPunch from '@/components/DinosPunch.vue'
  export default {
  components: { DinosPunch },
  }
</script>

<style scoped>

</style>